/* unplugin-vue-components disabled */import script from "./SearchBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchBar.vue?vue&type=script&lang=ts&setup=true"

import "./SearchBar.vue?vue&type=style&index=0&id=75e71482&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75e71482"]])

export default __exports__